import { render } from "./RemoteSearchSelect.vue?vue&type=template&id=c358c2c6"
import script from "./RemoteSearchSelect.vue?vue&type=script&lang=js"
export * from "./RemoteSearchSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__